import { Component, EventEmitter, Input, Output, Inject, LOCALE_ID, AfterViewInit, PLATFORM_ID } from '@angular/core';
import { BasePageComponent } from '../base-page/base-page.component';
import { InitialDataService } from 'src/app/services/page/initial-data.service';
import { take, takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LoggedStatus, UserFullInfo } from 'src/app/services/auth/login/login.models';
import { chickenRoad2, gameInfoTrx, gameTrx, liveCasinoTrx, loginTrx, searchGameTrx, signUpTrx, sportsBookTrx } from 'src/app/router-translation.labels';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { UserMessagesService } from 'src/app/services/user-messages/user-messages.service';
import { Language } from 'src/app/apollo/models/base-models';
import { CookieService } from 'ngx-cookie-service';
import { HOST_NAME } from 'src/app/global.tokens';
import { UploadDocumentsService } from 'src/app/services/profile/upload-documents.service';
import { sectionsData, DocumentData, UserDocumentsResponse, SectionCard, Status } from 'src/app/services/profile/upload-documents.models';
import { PendingWithdrawalService } from 'src/app/services/payment/withdrawal/pending-withdrawal.service';
import { PendingWithdrawalList } from 'src/app/services/payment/withdrawal/withdrawal.models';
import { PendingRewardsService } from 'src/app/services/prizes/pending-rewards.service';
import { PendingReward } from 'src/app/services/prizes/prizes.models';
import { UserFullInfoService } from 'src/app/services/auth/check-session/user-full-info.service';
import { isPlatformBrowser } from '@angular/common';
import { SearchGameComponent } from '../games/search-game/search-game.component';
import { extractLanguageCode, languageSwitchUrl } from 'src/app/utils/language-switch.utils';
import { hasRaffleAccess } from '../ticket-lottery/raffle-access.utils';
import { InstallPromptService, isAppMenuItem } from 'src/app/services/pwa/install-prompt.service';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent extends BasePageComponent implements AfterViewInit {


  sportsBookUrl: string = this.translationConfig.getTranslation(sportsBookTrx);
  liveCasinoRoute: string = `/${this.translationConfig.getTranslation(liveCasinoTrx)}`;
  slot: string = `/${this.translationConfig.getTranslation(gameTrx)}`;
  selectedLanguage: Language;

  constructor(
    public initialData: InitialDataService,
    private router: Router,
    protected loginStatus: LoginStatusService,
    public detectDeviceService: DetectDeviceService,
    protected translationConfig: TranslationConfig,
    protected licenceService: LicenceService,
    private userMessagesService: UserMessagesService,
    private documentService: UploadDocumentsService,
    private pendingListService: PendingWithdrawalService,
    private cookie: CookieService,
    private pendinRewardsService: PendingRewardsService,
    @Inject(HOST_NAME) public hostName,
    private userFullInfoService: UserFullInfoService,
    //public dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId,
    @Inject(LOCALE_ID) public locale,
    private installPromptService: InstallPromptService
  ) { super() }
  userInfo: UserFullInfo;
  isLogin: boolean = false;
  _isVisible: boolean = false;
  unreadMessages: number = 0;
  public userDocumentData: SectionCard[];
  hasDocumentRequest: boolean;
  pendingList: PendingWithdrawalList;
  pendingRewardsList:PendingReward[];
  userRole: boolean ;
  canSeeRaffle: boolean = false;


  @Input() set isVisible(value: boolean) {
    this._isVisible = value;
  }

  get isVisible(): boolean {
    return this._isVisible;
  }

  childData: any;
  allMenuItems: any[] = [];
  deferredPrompt: any;

  ngOnInit(): void {
    this.installPromptService.deferredPrompt$.pipe(takeUntil(this.unsubscribe)).subscribe(prompt => {
      this.deferredPrompt = prompt;
      if (this.childData?.topMenuItems) {
        const canInstall = this.detectDeviceService.canShowAppMenu(this.deferredPrompt);
        this.childData = { ...this.childData, topMenuItems: canInstall ? this.allMenuItems : this.filterMenuItems() };
      }
    });

    this.loginStatus.getLoginPartialStatus().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
      this.isLogin = resp;

      if (this.isLogin) {
        this.userMessagesService.unreadMessagesCount.pipe(take(1)).subscribe((unreadCount) => {
          this.unreadMessages = unreadCount;
        });
        this.pendinRewardsService.getPendingRewards().pipe(takeUntil(this.unsubscribe)).subscribe((resp) => {
          this.pendingRewardsList = resp;
        });
        this.documentService.updateUserDocuments();
        this.documentService.getUserDocuments().pipe(takeUntil(this.unsubscribe)).subscribe((userDocumentsResponse: UserDocumentsResponse) => {
          if (userDocumentsResponse) {
            this.userDocumentData = this.documentService.fillSectionCards(sectionsData, userDocumentsResponse, this.documentService.getSectionsCookie());
            this.hasDocumentRequest = !!this.userDocumentData.find((item) => !(item.status === this.documentService.translateStatus(Status.Approved) || item.status === this.documentService.translateStatus(Status.NotRequired)) && !item.is_hide);
          }
        });

        setTimeout(() => { // Side Nav count notifications api calls here
          this.pendingWithdrawalCheck();
        }, 0);
      }

      this.initialData.fetchData().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
        this.allMenuItems = resp.topMenuItems || [];
        const canInstall = this.detectDeviceService.canShowAppMenu(this.deferredPrompt);
        this.childData = { ...resp, topMenuItems: canInstall ? this.allMenuItems : this.filterMenuItems() };
        this.selectedLanguage = resp.languages.filter(item => {
          const parts = item.name.split("-");
          const langCode = parts[0] === "Lemon" && parts.length > 1 ? parts.slice(1).join().trim() : parts.join('-').trim();
          return langCode.toLowerCase() === this.locale.toLowerCase();
        })[0];
      });
    });

    // this.userFullInfoService.requestFullInfo(true).pipe(takeUntil(this.unsubscribe)).subscribe({
    //   next: (res) => {
    //     this.userInfo = res;
    //   },
    //   error: () => { },
    //   complete: () => { },
    // })

    this.loginStatus.getUserLoginStatus().pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (res) => {
        this.userInfo = res.fullInfo;
        const roleList = (res.fullInfo?.roles as string[]) || [];
        this.userRole = roleList.some(role => this.loginStatus.vipRoles.includes(role.toLowerCase()));
        this.canSeeRaffle = hasRaffleAccess(roleList);
      }
    })
  }

  // app menu item is visible only when the browser offers install (deferredPrompt), i.e. app not installed yet
  // safari never fires beforeinstallprompt, so it is shown there unless opened as the installed app
  filterMenuItems(): any[] {
    return this.allMenuItems.filter(menu => !isAppMenuItem(menu));
  }

  // english is a js only link so google cannot see it, the rest stay normal html links
  languageHref(item: any): string | null {
    if (languageSwitchUrl(item?.name)) {
      return null;
    }
    return item?.redirectUrl ? item.redirectUrl : null;
  }

  onLanguageClick(event: MouseEvent, item: any): void {
    const url = languageSwitchUrl(item?.name);
    if (url) {
      event.preventDefault();
      window.location.href = url;
      return;
    }
    if (item?.redirectUrl) {
      event.preventDefault();
      window.location.href = item.redirectUrl;
    }
  }

  setCookie($event: any) {
    const langCode = extractLanguageCode($event?.value);
    if (!langCode) {
      return;
    }
    this.cookie.set('language', langCode, 2592000, '/', this.hostName);
    const url = languageSwitchUrl($event?.value);
    if (url) {
      window.location.href = url;
      return;
    }
    const selected = this.childData?.languages?.find((item) => item?.name === $event?.value);
    if (selected?.redirectUrl) {
      window.location.href = selected.redirectUrl;
    }
  }

  @Output() closeNav = new EventEmitter();

  callLinkClickedParent(): void {
    this.closeNav.next("");
  }

  signup() {
    this.router.navigate(['', this.translationConfig.getTranslation(signUpTrx)], { state: { redirectTo: this.router.url } });
    this.callLinkClickedParent();
  }

  pendingWithdrawalCheck() {
    if (this.isLogin) {
      this.pendingListService.getList().subscribe();
      this.pendingListService.pendingWithdrawalsCount$.pipe(takeUntil(this.unsubscribe)).subscribe({
        next: (resp) => {
          this.pendingList = resp;
        },
        error: (error) => {
          // console.log(error)
        }
      });
      this.userMessagesService.unreadMessagesCount.pipe(takeUntil(this.unsubscribe)).subscribe((unreadCount) => {
        this.unreadMessages = unreadCount;
      });
    }
  }

  ngAfterViewInit(): void {
    // Side Nav count notifications api calls here
    this.pendingWithdrawalCheck();
  }

  login() {
    this.router.navigate(['', this.translationConfig.getTranslation(loginTrx)], { state: { redirectTo: this.router.url } });
    this.callLinkClickedParent();
  }

  openSearchDialog() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const searchPath = this.translationConfig.getTranslation(searchGameTrx);
    const currentUrl = this.router.url;

    if (currentUrl.includes(searchPath)) {
      this.callLinkClickedParent();
      return;
    }

    this.router.navigate([searchPath]);

    this.callLinkClickedParent();
  }

}
